import { render, staticRenderFns } from "./AdvertiseLanding.vue?vue&type=template&id=29d61fe2&scoped=true"
import script from "./AdvertiseLanding.vue?vue&type=script&lang=js"
export * from "./AdvertiseLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d61fe2",
  null
  
)

export default component.exports